<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Rawat Inap" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <!-- @include('blocks.page-content-header') -->
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <div class="card-with-tab mb-3">
            <div class="card-tab">
              <ul class="nav nav-tabs">
                <li class="nav-item">
                  <router-link to="/ranap" class="nav-link"
                    >Daftar Rawat Inap</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link to="/ranap/kamar" class="nav-link active"
                    >Daftar Kamar</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
          <div>
            <div class="row mb-3">
              <div class="col-md-12">
                <!-- @include('blocks.tabs') -->
                <b-tabs pills>
                  <b-tab
                    v-for="item in tabs"
                    v-bind:key="item.title + String(Math.random(1023))"
                    :title="item.title"
                    @click="() => filterTab(item.filter)"
                  />
                </b-tabs>
              </div>
            </div>
          </div>

          <div class="card card-filter-sort no-print">
            <div class="row">
              <div class="col-md-10">
                <!-- @each(input in filters) -->
                <!-- @include('blocks.formTemplate') -->
                <FormRow
                  :row="filters"
                  @handleChange="(e) => handleChange(e)"
                />
                <!-- @endeach -->
              </div>
              <div class="col-md-2">
                <!-- @each(input in sort) -->
                <!-- @include('blocks.formTemplate') -->
                <FormRow :row="sort" @handleChange="(e) => handleChange(e)" />
                <!-- @endeach -->
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <div class="row">
              <div class="col-md-3">
                <div class="row form-group mt-3">
                  <div class="col-md-12 d-flex flex-between">
                    <label class="mb-0 mr-3">Tampilkan</label>
                    <select class="form-control" v-model="perPage">
                      <option value="10">10 data</option>
                      <option v-if="rows.length > 10" value="25">
                        25 data
                      </option>
                      <option v-if="rows.length > 25" value="50">
                        50 data
                      </option>
                      <option v-if="rows.length > 50" value="100">
                        100 data
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-6 offset-md-3">
                <div class="form-group mt-3">
                  <input
                    type="text"
                    class="form-control with-icon-left without-label"
                    v-model="filter"
                    placeholder="Cari data di sini"
                    ref="focusMe"
                    @keydown="$event.stopImmediatePropagation()"
                  />
                  <i class="material-symbols-outlined">search</i>
                </div>
              </div>
            </div>
            <datatable
              :columns="columns"
              :per-page="10"
              :data="rows"
              :filter="filter"
              class="table table-hover responsive"
              v-if="loaded && rows.length"
            ></datatable>
            <EmptyState
              v-else-if="loaded && !rows.length"
              :data="{
                img: '/img/med.svg',
                size: 'small',
                title: `Tidak ada data`,
                content: `Tidak ada data kamar rawat inap yang ${status.toLowerCase()} dengan filter di atas`,
              }"
            />
            <Loading v-else />
            <br />
            <p v-if="rows.length">
              Menampilkan
              {{ rows.length > parseInt(perPage) ? perPage : rows.length }} data
              dari total {{ rows.length }} data
            </p>
            <datatable-pager
              v-model="page"
              class="nav nav-tabs datatable-pager"
              type="abbreviated"
              v-if="loaded && rows.length"
            ></datatable-pager>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Loading from "@/components/Loading.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import EmptyState from "@/components/EmptyState.vue";
let data = {
  title: "Rawat Inap",
  backBtn: "",
  actionBtn: [],
  breadcrumb: [],
};
let tabs = [
  // {title:'SEMUA',filter:'',link:'#',active:true},
  { title: "TERISI", filter: "TERISI", link: "#", active: true },
  { title: "KOSONG", link: "", filter: "KOSONG" },
];
let classes = [
  {
    value: "",
    label: "Semua",
  },
  {
    value: "VIP",
    label: "Kelas VIP",
  },
  {
    value: "I",
    label: "Kelas I",
  },
  {
    value: "II",
    label: "Kelas II",
  },
  {
    value: "III",
    label: "Kelas III",
  },
];
let sorts = [
  {
    value: "desc",
    label: "Terbaru",
  },
  {
    value: "asc",
    label: "Terlama",
  },
];
let filters = {
  colnum: "",
  columns: [
    {
      label: "Kelas Kamar",
      type: "select",
      placeholder: "Semua",
      value: "",
      name: "kelas",
      mandatory: true,
      options: classes,
      colwidth: 3,
      id: "filterClass",
    },
  ],
};
let sort = {
  colnum: 1,
  columns: [
    {
      label: "Sort By",
      type: "select",
      placeholder: "",
      value: "desc",
      mandatory: true,
      options: sorts,
      name: "orderBy",
    },
  ],
};
export default {
  name: "Ranap",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    Loading,
    EmptyState,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: data,
      filters: filters,
      sort: sort,
      tabs: tabs,
      orderBy: "desc",
      kelas: "",
      status: "TERISI",
      loaded: false,
      columns: [
        { label: "Kamar", field: "nama" },
        { label: "Nomor Kasur", field: "formatted_no_kasur" },
        { label: "Kelas", field: "formatted_kelas" },
        { label: "Biaya per Malam", field: "formatted_biaya" },
        { label: "Status", field: "status" },
        { label: "Sejak", field: "formatted_updated_at" },
        {
          label: "",
          class: "dropdown",
          representedAs: (item) =>
            item.status == "KOSONG"
              ? `<a class="btn btn-primary btn-with-icon-left" href="/#/ranap/daftar?id_kamar=${item.id}" style="display:inline-flex;min-width:9rem"><i class="material-symbols-outlined">add</i> Check In Ranap</a>`
              : `<a class="btn btn-success btn-with-icon-left" href="/#/ranap/detail/${item.id_ranap}" style="display:inline-flex;min-width:9rem"><i class="material-symbols-outlined">open_in_new</i> Lihat Data Ranap</a>`,
          interpolate: true,
        },
      ],
      filter: "",
      page: 1,
      countTotalRows: 0,
      perPage: 10,
      rows: [],
    };
  },
  methods: {
    async filterTab(filter) {
      this.page = 1;
      //console.log(this.page);
      this["status"] = filter;
      await this.displayList();
      this.$nextTick(() => {
        if (this.$refs.focusMe) {
          this.$refs.focusMe.focus();
        }
      });
    },
    async handleChange(e) {
      this[e.target.name] = e.target.value;
      await this.displayList();
      this.$nextTick(() => {
        if (this.$refs.focusMe) {
          this.$refs.focusMe.focus();
        }
      });
    },
    displayList: async function() {
      this.loaded = false;
      this.page = 1;
      this.errors = [];
      try {
        let params = `?per_page=99999999&orderBy=${this.orderBy}`;
        if (this.status) {
          params += `&status=${this.status}`;
        }
        if (this.kelas) {
          params += `&kelas=${this.kelas}`;
        }
        let result = await this.$store.state.HTTP.get(
          `ranap/fasilitas/kamar${params}`
        );
        //console.log(result);
        if (result.status == "200") {
          this.rows = result.data.data;
          this.loaded = true;
        } else {
          this.errors.push(result.status);
          this.loaded = true;
        }
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
        this.loaded = true;
      }
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    await this.displayList();
    this.$nextTick(() => {
      if (this.$refs.focusMe) {
        this.$refs.focusMe.focus();
      }
    });
  },
};
</script>
